import { useEffect, useRef } from 'react';
import { getMarketStatus } from '../design/marketHours';

export const AUTO_REFRESH_INTERVAL_MS = 60_000;

/**
 * Calls `refresh` every `intervalMs` while the NYSE session is open
 * (read-only "live feel" polling; see docs/plans/2026-07-23-ui-makeover-design.md).
 */
export function useAutoRefresh(
  refresh: () => void,
  intervalMs: number = AUTO_REFRESH_INTERVAL_MS,
): void {
  const cb = useRef(refresh);
  useEffect(() => { cb.current = refresh; });
  useEffect(() => {
    // No leading call by design: the consumer's own initial fetch handles
    // first load; this hook only drives subsequent refreshes.
    const id = setInterval(() => {
      if (getMarketStatus().open) cb.current();
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}
